import { api } from './client';
import type { Role } from '@/domain/roles';

export interface SessionResult {
  token: string;
  user: { id: string; email: string; name: string };
  organization: { id: string; name: string };
  roles: Role[];
}

/** 第一步：请求验证码。邮箱不在组织里会回 403 NOT_INVITED。 */
export async function sendLoginCode(email: string) {
  const { data } = await api.post<{ ok: true }>('/auth/code/send', { email });
  return data;
}

/** 第二步：用验证码换会话。 */
export async function verifyLoginCode(email: string, code: string) {
  const { data } = await api.post<SessionResult>('/auth/code/verify', { email, code });
  return data;
}
